import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Hub, ConsoleLogger } from "aws-amplify/utils";
import UsernameInput from "../Inputs/UsernameInput";
import PasswordInput from "../Inputs/PasswordInput";
import { LoadingButton } from "@mui/lab";
import { Alert, Button, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import useHashLocation from "../../../../use-hash-location";

const LogInForm = ({ setIsOpenPortal, onSubmit, isLoading, setIsLoading, setPasswordReset }) => {
  const formController = useForm({ mode: "onChange" });
  const [errorMessage, setErrorMessage] = useState(null);
  const { t } = useTranslation();

  const {
    handleSubmit,
    register,
    errors,
    formState: { isDirty, isValid },
  } = formController;

  useEffect(() => {
    if (isDirty || isValid) {
      setErrorMessage(null);
    }
  }, [isValid, isDirty]);

  const logger = new ConsoleLogger("My-Logger");

  const listener = (data) => {
    switch (data.payload.event) {
      case "signedIn":
        setIsOpenPortal(false);
        setIsLoading(false);
        setErrorMessage("");
        break;
      case "signedOut":
        logger.info("user signed out");
        break;
      // seems not to exist anymore AND no event is thrown?
      // moved to Authentication.jsx
      // https://docs.amplify.aws/gen1/react/build-a-backend/auth/auth-events/
      case "signIn_failure":
        logger.error("user sign in failed");
        setErrorMessage(data.payload.data.message);
        setIsLoading(false);
        break;
      default:
        logger.info("default event");
    }
  };

  Hub.listen("auth", listener);

  const loadingButtonStyle = {
    backgroundColor: "#66cc99",
    color: "#000000",
    "&:hover": {
      backgroundColor: "#37a46e",
    },
  };

  return (
    <>
      <form
        onSubmit={handleSubmit(onSubmit)}
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Stack direction="column" gap={2}>
          {errorMessage && (
            <Alert severity="error">
              <span>{errorMessage}</span>
            </Alert>
          )}

          <UsernameInput
            errors={errors}
            register={register}
            formController={formController}
            label={t("L1_INPUT_ENTER_YOUR_EMAIL")}
          />

          <PasswordInput errors={errors} register={register} formController={formController} label={t("L1_INPUT_PASSWORD")} />

          <LoadingButton
            type="submit"
            loading={isLoading}
            disabled={!isValid || !isDirty}
            variant="contained"
            sx={loadingButtonStyle}
          >
            {t("BUTTON_LOGIN")}
          </LoadingButton>

          <Button
            size="small"
            onClick={() => setPasswordReset(true)}
            sx={{
              marginTop: "2px",
              color: "#000000",
            }}
          >
            {t("L1_LOGIN_FORGOT_YOUR_PASSWORD")}
          </Button>
        </Stack>
      </form>
    </>
  );
};

export default LogInForm;
